import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in en.checklists.index.tsx.
export const Route = createFileRoute("/en/checklists")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
